import { Component, Input, OnDestroy, OnInit,ViewEncapsulation } from '@angular/core';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs/internal/Subject';
import { PageContent } from 'src/app/core/models/page-content';
import { PageContentService } from 'src/app/core/services/page-content.service';

@Component({
  selector: 'app-page-content',
  templateUrl: './page-content.component.html',
  encapsulation:ViewEncapsulation.None,
  styleUrls: ['./page-content.component.scss']
})
export class PageContentComponent implements OnInit,OnDestroy{
  @Input('name') name: string;
  pagecontent:PageContent;
  destroy$: Subject<boolean> =new Subject<boolean>();

  constructor(
    private pagecontentService: PageContentService,) {}

  ngOnInit(): void {
      this.getPageContent(this.name)
  }

  ngOnDestroy(): void{
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }

  getPageContent(code:string ) {
    this.pagecontentService.getByName(encodeURIComponent(code)).pipe(takeUntil(this.destroy$)).subscribe(data => {
      this.pagecontent = data;
    },
    error => {
      console.log("error: ",error);
    });
  }

  public trackByFnPageContent(index, item) {
    if (!item) return null;
    return item.id;
  }  

}
